// Wraps protected routes. Four states:
//   loading  → page skeleton (no auth-flicker into login, no spinner)
//   error    → soft retry UI; do NOT redirect to /welcome — a transient /api/me
//              500 (D1 hiccup, Worker mid-deploy) on a logged-in user would
//              otherwise force them through self-signup and create a duplicate
//              orphan account.
//   no user  → redirect to /welcome (self-onboarding is the primary entry;
//              /login still works as a class-code fallback)
//   has user → render children

import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { PageSkeleton } from '../components/Skeleton.tsx'
import { useMe } from './hooks.ts'

export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: user, isPending, isError, refetch } = useMe()
  const location = useLocation()

  if (isPending) return <PageSkeleton />
  if (isError) {
    return (
      <main className="mx-auto flex min-h-full max-w-md flex-col items-center justify-center gap-4 p-8 text-center">
        <p className="text-base text-[var(--color-fg)]">連線出了點問題</p>
        <p className="text-sm text-[var(--color-muted)]">等一下再試一次</p>
        <button
          type="button"
          onClick={() => {
            void refetch()
          }}
          className="rounded-[var(--radius-pill)] bg-[var(--color-joseph-primary)] px-5 py-2 text-sm font-semibold text-white"
        >
          重新載入
        </button>
      </main>
    )
  }
  if (!user) return <Navigate to="/welcome" replace state={{ from: location.pathname }} />
  return <>{children}</>
}
